const objectClassList = (arg) => {
    if (typeof arg !== 'object') {
        return arg;
    }
    return Object.entries(arg)
        .filter(([, value]) => !!value)
        .map(([key]) => key)
        .join(' ');
};
export const conditionalClassList = (...args) => {
    return args
        .filter((arg) => typeof arg === 'string' || typeof arg === 'object')
        .map(objectClassList)
        .filter((arg) => !!arg)
        .join(' ');
};
export const classList = (...args) => args.filter((arg) => !!arg).join(' ');
export const addLoadingClass = (loading) => (loading ? 'atds-skeleton-load' : '');
